/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Logout200Response
 */
export interface Logout200Response {
    /**
     * 
     * @type {boolean}
     * @memberof Logout200Response
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Logout200Response
     */
    message?: string;
}

/**
 * Check if a given object implements the Logout200Response interface.
 */
export function instanceOfLogout200Response(value: object): value is Logout200Response {
    return true;
}

export function Logout200ResponseFromJSON(json: any): Logout200Response {
    return Logout200ResponseFromJSONTyped(json, false);
}

export function Logout200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Logout200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function Logout200ResponseToJSON(json: any): Logout200Response {
    return Logout200ResponseToJSONTyped(json, false);
}

export function Logout200ResponseToJSONTyped(value?: Logout200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

